export { default } from './AllInclusive';
